export default "__VITE_ASSET__BR78o5cJ__"